import React, { useEffect, useState } from 'react';
import { Button, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import {
  kuruluMu,
  yuklemeyiBaslat,
  yuklenebilirlikAbone,
  yuklenebilirMi,
} from '../../utils/pwaInstall';

/**
 * "Uygulamayı Yükle" — siteyi ana ekrana kurar (Android / masaüstü Chrome).
 *
 * NEDEN VAR: veliler Chrome'un ⋮ menüsündeki "Ana ekrana ekle" seçeneğini
 * BULAMIYOR (23.09.2026, Eren Bey bildirdi). Menüyü tarif etmek yerine
 * işlemi uygulamanın içine aldık — tek dokunuş.
 *
 * YÜKLEMEK NEDEN ÖNEMLİ (Android'de bildirim kurulmadan da çalışıyor):
 * kurulmamış sitede bildirimler "Chrome · arys.aliagarobotik.com" olarak
 * görünüyor; kurulduğunda uygulama adı ve kurum logosuyla çıkıyor.
 * iOS'ta ise bildirim KURULMADAN hiç çalışmıyor (Apple'ın kısıtı) ama
 * Safari bu olayı desteklemediği için düğme orada çizilmez —
 * `BildirimIzniDugmesi` iPhone'da adımları anlatıyor.
 *
 * OLAY BURADA DİNLENMİYOR, `utils/pwaInstall` modülünde yakalanıyor:
 * `beforeinstallprompt` sayfa açılışında bir kez tetikleniyor ve bu düğme
 * kapalı bir Popover içinde olduğu için o anda henüz mount olmuyordu —
 * olay kaçıyor ve düğme hiç görünmüyordu.
 */
const UygulamayiYukleDugmesi = ({ gorunum = 'link' }) => {
  const [gosterilsin, setGosterilsin] = useState(() => yuklenebilirMi() && !kuruluMu());
  const [yukleniyor, setYukleniyor] = useState(false);

  useEffect(() => {
    if (kuruluMu()) return;
    // Modül olayı bu bileşen mount olmadan önce yakalamış olabilir;
    // mevcut durumu bir kez okuyup sonra değişiklikleri dinliyoruz.
    setGosterilsin(yuklenebilirMi());
    return yuklenebilirlikAbone((durum) => setGosterilsin(durum));
  }, []);

  if (!gosterilsin) return null;

  const yukle = async () => {
    setYukleniyor(true);
    await yuklemeyiBaslat();
    setYukleniyor(false);
  };

  return (
    <Tooltip title="Ana ekrana ekler; bildirimler uygulama adıyla gelir">
      <Button
        type={gorunum === 'link' ? 'link' : 'primary'}
        ghost={gorunum !== 'link'}
        size="small"
        loading={yukleniyor}
        icon={<DownloadOutlined />}
        onClick={yukle}
      >
        Uygulamayı Yükle
      </Button>
    </Tooltip>
  );
};

export default UygulamayiYukleDugmesi;
